// stg用データにしか使用されない処理
// raceEventCode.jsonに未登録のコード（key）の場合に実行（表示）される

import buildRace from './buildRace'

export default (raceCode, races, targetId = 'ranking') => {

  const init = () => {
    if (!/^pist6.com/.test(location.hostname)) {
      buildExceptionPanel();
    }
  }

  const buildExceptionPanel = () => {
    const roundListUl = document.getElementById(targetId);
    const roundListUlClassname = `.${roundListUl.className.replace(/\s/g, '.')}`;
    const roundsListItem = roundListUl.closest('.le-rounds__list-item');

    const displayRaceCode = Object.values(raceCode);
    const exceptionRaceCodeKeys = Object.keys(races).filter(key => !displayRaceCode.includes(key));
    exceptionRaceCodeKeys.forEach((raceCode, rIdx) => {
      const cloneListItem = roundsListItem.cloneNode(true);
      const cloneInnerRoundList = cloneListItem.querySelector(roundListUlClassname);
      cloneInnerRoundList.id = `exeption${rIdx}`;

      buildRace(cloneInnerRoundList, races[raceCode], {});

      cloneListItem.querySelector('.c-race-header__ttl-sub span').textContent = 'Exeption';
      cloneListItem.querySelector('.c-race-header__ttl-main span').textContent = `レース種目該当なし コード [ ${raceCode} ]`;

      roundsListItem.after(cloneListItem);
    })

  }

  init();
}
